"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownMenuItemType = void 0;
var SelectableOption_1 = require("../../SelectableOption");
Object.defineProperty(exports, "DropdownMenuItemType", { enumerable: true, get: function () { return SelectableOption_1.SelectableOptionMenuItemType; } });
//# sourceMappingURL=Dropdown.types.js.map